import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(accidentWallEmployeeRoute);

    /** @ngInject */
    function accidentWallEmployeeRoute($stateProvider) {
        $stateProvider.state('company_employee.issue_list', {
            url: '/biezace-awarie',
            template:
                require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/issues/company_issue_list/company_issue_list.html'),
            controller: 'CompanyIssueListController',
            controllerAs: 'CompanyIssueListCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/company_issue_list.route.ts